export default "__VITE_ASSET__DLSKtLCo__"